import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { GrInstagram } from "react-icons/gr";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp, FaFacebookF, FaYoutube } from "react-icons/fa";
const Footer = () => {
  return (
    <>
        <footer className="py-5">
            <Container className="p-lg-0">
                <Row className='mx-0 border-bottom mb-2 pb-3'>
                    <Col lg={9} className="mb-4">
                        <ul className="footer-list">
                            <li>
                                <h6>Shop</h6>
                                <Link to="/shop">Shop Wedding</Link>
                                <h6 className="mt-3">Follow Us</h6>
                                <div className="d-flex gap-3 socialicon">
                                    <Link to="https://www.facebook.com/grapheweddings" target="_blank" rel="noopener noreferrer"><FaFacebookF /></Link>
                                    <Link to="https://www.instagram.com/grapheweddings/" target="_blank" rel="noopener noreferrer"><GrInstagram /></Link>
                                    <Link to="https://www.youtube.com/channel/UCrupfKu67XWzBHB-i9oiquQ" target="_blank" rel="noopener noreferrer"><FaYoutube /></Link>
                                </div>
                            </li>
                            <li>
                                <h6>Get In Touch</h6>
                                {/* <Link to="/about-us">About Us</Link> */}
                                <Link to="/contact-us">Contact Us</Link>
                                <Link to="/faqs">FAQs</Link>
                            </li>
                             <li>
                                <h6>Legal Policies</h6>
                                <Link to="/terms-and-conditions">Terms & Conditions</Link>
                                <Link to="/privacy-policy">Privacy Policy</Link>
                                <Link to="/cookie-policy">Cookie Policy</Link>
                                <Link to="/refund-policy">Refund Policy</Link>
                                <Link to="/shipping-policy">Shipping Policy</Link>
                            </li>
                        </ul>
                    </Col>
                    <Col lg={3} className="mb-4">
                        <h6>Quick Contact</h6>
                        <p className="mb-2 mt-3">
                            <a
                                href="tel:+9836610337"
                                className="mb-0 text-dark text-decoration-none"
                            >
                            <FaPhoneAlt className="me-1 text-dark" />
                            <span>+91 9836610337</span>
                            </a>
                        </p>
                        <p className="mb-2">
                            <a
                                href={`https://wa.me/919836610337?text=${encodeURIComponent(
                                    `Hi, I'm interested in your services. Please share pricing & details.
                                    Thank you!`
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none text-dark"
                            >
                            <FaWhatsapp className="me-1 text-success" />
                            <span>+91 9836610337</span>
                            </a>
                        </p>
                        <p className="mb-0">
                            <FaEnvelope className="me-1 text-dark" />
                            <span>contact@grapheweddings.com</span>
                        </p>
                        {/* <p>Sign up to receive information about new arrivals, future events and specials.</p>
                        <form>
                            <div className="mb-3">
                                <input type="email" className="form-control" placeholder="Enter your email" />
                            </div>
                            <Button className="btn btn-sm btn-dark rounded-pill px-3">Subscribe</Button>
                        </form> */}
                    </Col>
                </Row>
                <p className="mb-0 text-center text-secondary"><small> &copy; {new Date().getFullYear()} Wedding Stationery. All rights reserved.</small></p>
            </Container>
        </footer>
    </>
  )
}

export default Footer
